const LS_CONTINUE_TRACE = "DEBUG_PUBLIC_OFFER_CONTINUE_FLOW";

/** @type {Record<string, string>} */
const _lastTraceFp = Object.create(null);

function _isDev() {
  try {
    return import.meta.env?.DEV === true;
  } catch {
    return false;
  }
}

function _verbose() {
  try {
    return typeof localStorage !== "undefined" && localStorage.getItem(LS_CONTINUE_TRACE) === "1";
  } catch {
    return false;
  }
}

/**
 * @param {object} payload
 * @param {{ force?: boolean }} [opts]
 */
export function logPublicOfferContinueFlowTrace(payload, opts = {}) {
  if (!_isDev() || !payload) return;
  const key = String(payload.packageId ?? payload.source ?? "flow");
  const fp = JSON.stringify(payload);
  if (!opts.force && !_verbose() && _lastTraceFp[key] === fp) return;
  _lastTraceFp[key] = fp;
  // eslint-disable-next-line no-console
  console.info("[PUBLIC_OFFER_CONTINUE_FLOW_TRACE]", payload);
}
